import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { CoreLogService } from '../../services/log.service';
import { CoreLanguageService } from '../../services/language.service';
import { InHouseOrderService } from '../../services/inHouseOrder.service';
import { IUiData } from '../../services/IInHouseOrderService';
import { WebShopService } from '../../services/webShop.service';
import { InternationalisationService } from '../../forked/angular-internationalisation';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'ya-inHouseTableButton',
  templateUrl: './inHouseTableButton.component.html',
  styleUrls: ['./inHouseTableButton.component.scss'],
})
export class InHouseTableButtonComponent implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;
  @ViewChild('infocontainer') infocontainer: ElementRef;

  private _langSubscriber: Subscription;
  private _inHouseUiDataSubscription: Subscription;

  /** Status ob es eingefahren oder ausgefahren ist. initial ausgefahren */
  public expanded: boolean = true;
  public inHouseIsGroup: boolean = false;
  public tableNumberText: string;
  private table_no: string;
  public openItemsText: string;
  private open_items: number;
  public open_price: number;

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _internationalisationService: InternationalisationService
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _inHouseOrderService: InHouseOrderService
    , private _webShopService: WebShopService
    , private _router: Router
  ) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("InHouseTableButtonComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;

    me.updateUiData(me._inHouseOrderService.UiData);
    // bei änderung des Tisches im InHouseOrder entsprechend die UI aktualisieren
    me._inHouseUiDataSubscription = me._inHouseOrderService.ObserveUiDataChanged.subscribe((newUiData) => {
      me.updateUiData(newUiData);
      me.PushChanges();
    });

    // text erneuern
    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.renderText()
      me.PushChanges();
    });

    me.PushChanges();
  }

  ngOnDestroy() {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._inHouseUiDataSubscription) {
      me._inHouseUiDataSubscription.unsubscribe();
    }
  }

  /** aktualisiert die Daten und auch den abhängigen text */
  private updateUiData(UiData: IUiData): void {
    const me = this;
    me.table_no = UiData.table_no;
    me.open_items = UiData.open_amount;
    me.open_price = UiData.open_price;
    me.inHouseIsGroup = UiData.isGroup;
    me.renderText();
  }

  public get groupName(): string {
    return this._inHouseOrderService.GroupName;
  }

  public get mandatoryPayment() {
    return this._inHouseOrderService.TableData.mandatory_Payment;
  }

  /** rendert erneut tableNumberText und openItemsText */
  private renderText(): void {
    const me = this;
    if (!me.inHouseIsGroup) {
      me.tableNumberText = me._coreLanguageService.value("phInHouseService_Table")
        .replace("{table_no}", me.table_no);
    }
    me.openItemsText = me._coreLanguageService.value("phInHouseService_Items")
      .replace("{items_count}", me.open_items.toString());
  }

  /** ein-/ausfahren des buttons */
  public toggleExpand(): void {
    const me = this;
    me.expanded = !me.expanded;
    // lase den container um die breite des infocontainers aus dem bild fahren, oder auf 0 zurückkehren
    const rightPosition = me.expanded ? 0 : (-me.infocontainer.nativeElement.offsetWidth);
    me.container.nativeElement.setAttribute('style', 'right: ' + rightPosition + "px");
    me.PushChanges();
  }

  /** preis wie im Shop ausgeben */
  public priceFormatter(price: number): string {
    const me = this;
    return me._webShopService.formatCurrency(price);
  }

  /** navigiert zur InHouse Landingpage */
  public navigateToTable(): Promise<void> {
    const me = this;
    return me._inHouseOrderService.openInHauseLandingPage();
  }

  /** navigiert zur InHouse Landingpage */
  public navigateToGroupOrder() {
    const me = this;
    me._router.navigate(["/groupOrderServiceSelector"]);
  }
}


